"use strict";
var controller = function($scope, $rootScope, $http) {
  $scope.deleteExport = function(exportt) {
    $scope.showDelete = true;
    $scope.activeExport = exportt;
  };
  var getList = function() {
    $scope.loading = true;
    var params = {};
    $http.get('api/export.json', {params: params}).success(function(data, status, headers, config) {
      $scope.exports = data.exports;
      $scope.count = data.count;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.remove = function() {
    $http.delete('api/export/' + $scope.activeExport.filename + '.json', {}).success(function(data, status, headers, config) {}).catch(function(data, status, headers, config) {}).finally(function() {
      getList();
      $scope.showDelete = false;
      $scope.activeExport = null;
    });
  };
  var init = function() {
    getList();
  }();
};
module.exports = controller;
